import moment from 'moment'
import { convertToUTC } from 'shared/utils/timezone'

export const splitTimeRange = (start: string, end: string) => {
    const startTime = moment(start, 'HH:mm')
    const endTime = moment(end, 'HH:mm')

    if (endTime.isSameOrAfter(startTime)) {
        return [{ start, end }]
    }

    const midnight = moment('00:00', 'HH:mm').format('HH:mm:ss.SSS[Z]')

    return [
        { start, end: midnight },
        { start: midnight, end },
    ]
}

export const parseTimeRange = (timeRanges: string) => {
    const ranges = timeRanges.split(',').map(range => range.trim())

    return ranges.flatMap(timeRange => {
        const [start, end] = timeRange.split(' - ').map(time => time.trim())
        const [utcStart, utcEnd] = [convertToUTC(start), convertToUTC(end)]

        return splitTimeRange(utcStart, utcEnd)
    })
}
